import { atom } from "jotai";

export const visibleModalAlertaAtom = atom(false);
